export default "__VITE_ASSET__DqEfsEX7__"